import React from 'react'
import styles from './styles.module.css'

export const setItem = (secret, key, value) => {
  const encrypted = crypt(secret, value);
  localStorage.setItem(key, encrypted)
}

export const getItem = (secret, key) => {
  const encrypted = localStorage.getItem(key);
  if(encrypted != null) {
    return decrypt(secret, encrypted);
  } else {
    return null;
  }
  
}


const crypt = (salt, text) => {
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
  const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);

  return text
    .split("")
    .map(textToChars)
    .map(applySaltToChar)
    .map(byteHex)
    .join("");
};

const decrypt = (salt, encoded) => {
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
  return encoded
    .match(/.{1,2}/g)
    .map((hex) => parseInt(hex, 16))
    .map(applySaltToChar)
    .map((charCode) => String.fromCharCode(charCode))
    .join("");
};
